import openWindow from '@/script/openWindow.mjs'

export default () => {
    return (map, nodes) => {
        if (1 < nodes.size) {
            return null
        }

        const onClick = async () => {
            const [db] = nodes
            const {dbCode, pkid: dbId, prjId, sVer} = db.data
            openWindow('/ErDetail', {dbCode, dbId, prjId, sVer})
        }

        return {
            label: '查看ER图',
            onClick,
        }
    }
}
